import { Component, Input, output, ViewChild } from '@angular/core';
import { Drawer, DrawerModule } from 'primeng/drawer';
import { LanguageService } from 'core-lib';
import { SettingsService } from 'core-lib';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AvailabilityService } from 'core-lib';
import { ImageGallery1Component } from "../image-gallery1/image-gallery1.component";
import { ButtonModule } from 'primeng/button';
import { SelectButtonModule } from 'primeng/selectbutton';
import { FormsModule } from '@angular/forms';
import { GalleryRef } from 'ng-gallery';


@Component({
    selector: 'app-availability-room-readmore',
    imports: [DrawerModule, TranslateModule, ImageGallery1Component, ButtonModule, SelectButtonModule, FormsModule],
    templateUrl: './availability-room-readmore.component.html',
    styleUrl: './availability-room-readmore.component.scss'
})
export class AvailabilityRoomReadmoreComponent {

  @ViewChild('drawerRef') drawerRef!: Drawer;

  @ViewChild(ImageGallery1Component, { static: false })
  private imageGalleryComponent: ImageGallery1Component;
  
  @Input() roomData: any; 
  @Input() visible:boolean = false;
  @Input() hotelCode: string;
  onHideReadmore:any = output();  
  language:string;

  stateOptions: any[] = [];

  stateValue: string = 'details';
  
  constructor(private settings:SettingsService, private translateService: TranslateService, private avService: AvailabilityService){}

  ngOnInit(): void {

   

    this.language = this.translateService.currentLang;

    this.stateOptions.push(
      { label: this.translateService.instant('av.RoomDetails'), value: 'details' }
    );
    this.stateOptions.push(
      { label: this.translateService.instant('av.Images'), value: 'images' }
    );
   
    
  }

  handleOnHide(e:any) {
    this.drawerRef.close(e);
    this.onHideReadmore.emit();
  }

  handleOptionChange(event:any) {
    if (event.option.value == "images") {
      this.imageGalleryComponent.reset();
    }
  }

  getCategoryName(cat:string) {
    return this.avService.getCategoryName(cat);
  }

  
}
